var _path, _g, _path2, _path3, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14893_8710",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 600,
    height: 498
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M600 0H0V498H600V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14893_8710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300 580C454.64 580 580 454.64 580 300C580 145.36 454.64 20 300 20C145.36 20 20 145.36 20 300C20 454.64 145.36 580 300 580Z",
    fill: "#C4C4C4"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M300 345C363.513 345 415 293.513 415 230C415 166.487 363.513 115 300 115C236.487 115 185 166.487 185 230C185 293.513 236.487 345 300 345Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_14893_8710",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 560,
    height: 560
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M300 580C454.64 580 580 454.64 580 300C580 145.36 454.64 20 300 20C145.36 20 20 145.36 20 300C20 454.64 145.36 580 300 580Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_14893_8710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300 755C413.218 755 505 663.218 505 550C505 436.782 413.218 345 300 345C186.782 345 95 436.782 95 550C95 663.218 186.782 755 300 755Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.50579c2d5f5f32f4a4b5d213945be3a5.svg";
export { ForwardRef as ReactComponent };